export const NAME = 'harvesterManager';

export const KIND = { MACHINE_TEMPLATE: 'HarvesterMachineTemplate' };
